export function LoadingScreen() {
  return (
    <div className="fixed inset-0 bg-zinc-900 flex items-center justify-center">
      <div className="animate-spin rounded-full h-12 w-12 border-4 border-lime-500 border-t-transparent" />
    </div>
  );
}
